var map = {
	"./Binary_Property/ASCII.js": 2238,
	"./Binary_Property/ASCII_Hex_Digit.js": 64582,
	"./Binary_Property/Alphabetic.js": 54158,
	"./Binary_Property/Any.js": 67831,
	"./Binary_Property/Assigned.js": 22393,
	"./Binary_Property/Bidi_Control.js": 9313,
	"./Binary_Property/Bidi_Mirrored.js": 60128,
	"./Binary_Property/Case_Ignorable.js": 22185,
	"./Binary_Property/Cased.js": 11221,
	"./Binary_Property/Changes_When_Casefolded.js": 18352,
	"./Binary_Property/Changes_When_Casemapped.js": 21501,
	"./Binary_Property/Changes_When_Lowercased.js": 19933,
	"./Binary_Property/Changes_When_NFKC_Casefolded.js": 59813,
	"./Binary_Property/Changes_When_Titlecased.js": 6156,
	"./Binary_Property/Changes_When_Uppercased.js": 78570,
	"./Binary_Property/Dash.js": 21857,
	"./Binary_Property/Default_Ignorable_Code_Point.js": 5531,
	"./Binary_Property/Deprecated.js": 2444,
	"./Binary_Property/Diacritic.js": 83231,
	"./Binary_Property/Emoji.js": 44447,
	"./Binary_Property/Emoji_Component.js": 71575,
	"./Binary_Property/Emoji_Modifier.js": 45951,
	"./Binary_Property/Emoji_Modifier_Base.js": 41959,
	"./Binary_Property/Emoji_Presentation.js": 60370,
	"./Binary_Property/Extended_Pictographic.js": 7584,
	"./Binary_Property/Extender.js": 94014,
	"./Binary_Property/Grapheme_Base.js": 15218,
	"./Binary_Property/Grapheme_Extend.js": 43051,
	"./Binary_Property/Hex_Digit.js": 80758,
	"./Binary_Property/IDS_Binary_Operator.js": 99250,
	"./Binary_Property/IDS_Trinary_Operator.js": 15120,
	"./Binary_Property/ID_Continue.js": 70726,
	"./Binary_Property/ID_Start.js": 13407,
	"./Binary_Property/Ideographic.js": 8694,
	"./Binary_Property/Join_Control.js": 17143,
	"./Binary_Property/Logical_Order_Exception.js": 10175,
	"./Binary_Property/Lowercase.js": 63476,
	"./Binary_Property/Math.js": 86835,
	"./Binary_Property/Noncharacter_Code_Point.js": 30266,
	"./Binary_Property/Pattern_Syntax.js": 79569,
	"./Binary_Property/Pattern_White_Space.js": 87248,
	"./Binary_Property/Quotation_Mark.js": 25175,
	"./Binary_Property/Radical.js": 36443,
	"./Binary_Property/Regional_Indicator.js": 21130,
	"./Binary_Property/Sentence_Terminal.js": 15651,
	"./Binary_Property/Soft_Dotted.js": 28256,
	"./Binary_Property/Terminal_Punctuation.js": 46314,
	"./Binary_Property/Unified_Ideograph.js": 78351,
	"./Binary_Property/Uppercase.js": 68289,
	"./Binary_Property/Variation_Selector.js": 92598,
	"./Binary_Property/White_Space.js": 45661,
	"./Binary_Property/XID_Continue.js": 6226,
	"./Binary_Property/XID_Start.js": 68899,
	"./General_Category/Cased_Letter.js": 52338,
	"./General_Category/Close_Punctuation.js": 31452,
	"./General_Category/Connector_Punctuation.js": 93591,
	"./General_Category/Control.js": 10986,
	"./General_Category/Currency_Symbol.js": 81243,
	"./General_Category/Dash_Punctuation.js": 99476,
	"./General_Category/Decimal_Number.js": 22918,
	"./General_Category/Enclosing_Mark.js": 25681,
	"./General_Category/Final_Punctuation.js": 47432,
	"./General_Category/Format.js": 93100,
	"./General_Category/Initial_Punctuation.js": 51580,
	"./General_Category/Letter.js": 9715,
	"./General_Category/Letter_Number.js": 60443,
	"./General_Category/Line_Separator.js": 77569,
	"./General_Category/Lowercase_Letter.js": 50325,
	"./General_Category/Mark.js": 22606,
	"./General_Category/Math_Symbol.js": 91532,
	"./General_Category/Modifier_Letter.js": 85709,
	"./General_Category/Modifier_Symbol.js": 47625,
	"./General_Category/Nonspacing_Mark.js": 435,
	"./General_Category/Number.js": 17918,
	"./General_Category/Open_Punctuation.js": 94248,
	"./General_Category/Other.js": 11065,
	"./General_Category/Other_Letter.js": 46252,
	"./General_Category/Other_Number.js": 22821,
	"./General_Category/Other_Punctuation.js": 72794,
	"./General_Category/Other_Symbol.js": 368,
	"./General_Category/Paragraph_Separator.js": 5389,
	"./General_Category/Private_Use.js": 31416,
	"./General_Category/Punctuation.js": 28755,
	"./General_Category/Separator.js": 70968,
	"./General_Category/Space_Separator.js": 45189,
	"./General_Category/Spacing_Mark.js": 33452,
	"./General_Category/Surrogate.js": 38497,
	"./General_Category/Symbol.js": 85071,
	"./General_Category/Titlecase_Letter.js": 45668,
	"./General_Category/Unassigned.js": 3492,
	"./General_Category/Uppercase_Letter.js": 62778,
	"./Property_of_Strings/Basic_Emoji.js": 22515,
	"./Property_of_Strings/Emoji_Keycap_Sequence.js": 74310,
	"./Property_of_Strings/RGI_Emoji.js": 34499,
	"./Property_of_Strings/RGI_Emoji_Flag_Sequence.js": 70850,
	"./Property_of_Strings/RGI_Emoji_Modifier_Sequence.js": 29851,
	"./Property_of_Strings/RGI_Emoji_Tag_Sequence.js": 58094,
	"./Property_of_Strings/RGI_Emoji_ZWJ_Sequence.js": 87399,
	"./Script/Adlam.js": 44740,
	"./Script/Ahom.js": 57248,
	"./Script/Anatolian_Hieroglyphs.js": 47967,
	"./Script/Arabic.js": 21325,
	"./Script/Armenian.js": 19758,
	"./Script/Avestan.js": 70379,
	"./Script/Balinese.js": 9194,
	"./Script/Bamum.js": 69615,
	"./Script/Bassa_Vah.js": 5127,
	"./Script/Batak.js": 93702,
	"./Script/Bengali.js": 99583,
	"./Script/Bhaiksuki.js": 71072,
	"./Script/Bopomofo.js": 44148,
	"./Script/Brahmi.js": 62462,
	"./Script/Braille.js": 9344,
	"./Script/Buginese.js": 4209,
	"./Script/Buhid.js": 77207,
	"./Script/Canadian_Aboriginal.js": 73635,
	"./Script/Carian.js": 29755,
	"./Script/Caucasian_Albanian.js": 86038,
	"./Script/Chakma.js": 8388,
	"./Script/Cham.js": 69836,
	"./Script/Cherokee.js": 39389,
	"./Script/Chorasmian.js": 99358,
	"./Script/Common.js": 44472,
	"./Script/Coptic.js": 68447,
	"./Script/Cuneiform.js": 77839,
	"./Script/Cypriot.js": 26007,
	"./Script/Cypro_Minoan.js": 32003,
	"./Script/Cyrillic.js": 50496,
	"./Script/Deseret.js": 56739,
	"./Script/Devanagari.js": 28663,
	"./Script/Dives_Akuru.js": 29835,
	"./Script/Dogra.js": 48038,
	"./Script/Duployan.js": 18005,
	"./Script/Egyptian_Hieroglyphs.js": 57789,
	"./Script/Elbasan.js": 66763,
	"./Script/Elymaic.js": 37079,
	"./Script/Ethiopic.js": 65104,
	"./Script/Georgian.js": 87003,
	"./Script/Glagolitic.js": 71412,
	"./Script/Gothic.js": 90771,
	"./Script/Grantha.js": 11440,
	"./Script/Greek.js": 4289,
	"./Script/Gujarati.js": 58650,
	"./Script/Gunjala_Gondi.js": 11697,
	"./Script/Gurmukhi.js": 9543,
	"./Script/Han.js": 31250,
	"./Script/Hangul.js": 48840,
	"./Script/Hanifi_Rohingya.js": 84824,
	"./Script/Hanunoo.js": 36987,
	"./Script/Hatran.js": 21759,
	"./Script/Hebrew.js": 59618,
	"./Script/Hiragana.js": 6650,
	"./Script/Imperial_Aramaic.js": 84883,
	"./Script/Inherited.js": 47663,
	"./Script/Inscriptional_Pahlavi.js": 31866,
	"./Script/Inscriptional_Parthian.js": 81444,
	"./Script/Javanese.js": 25132,
	"./Script/Kaithi.js": 22095,
	"./Script/Kannada.js": 28189,
	"./Script/Katakana.js": 86259,
	"./Script/Kayah_Li.js": 78117,
	"./Script/Kharoshthi.js": 83572,
	"./Script/Khitan_Small_Script.js": 74788,
	"./Script/Khmer.js": 27688,
	"./Script/Khojki.js": 79543,
	"./Script/Khudawadi.js": 65991,
	"./Script/Lao.js": 40469,
	"./Script/Latin.js": 13707,
	"./Script/Lepcha.js": 15940,
	"./Script/Limbu.js": 38366,
	"./Script/Linear_A.js": 84636,
	"./Script/Linear_B.js": 91589,
	"./Script/Lisu.js": 49466,
	"./Script/Lycian.js": 77409,
	"./Script/Lydian.js": 50230,
	"./Script/Mahajani.js": 7148,
	"./Script/Makasar.js": 18349,
	"./Script/Malayalam.js": 70714,
	"./Script/Mandaic.js": 13166,
	"./Script/Manichaean.js": 32332,
	"./Script/Marchen.js": 60785,
	"./Script/Masaram_Gondi.js": 80931,
	"./Script/Medefaidrin.js": 61131,
	"./Script/Meetei_Mayek.js": 13854,
	"./Script/Mende_Kikakui.js": 58182,
	"./Script/Meroitic_Cursive.js": 41849,
	"./Script/Meroitic_Hieroglyphs.js": 57200,
	"./Script/Miao.js": 34199,
	"./Script/Modi.js": 46374,
	"./Script/Mongolian.js": 91009,
	"./Script/Mro.js": 21065,
	"./Script/Multani.js": 46261,
	"./Script/Myanmar.js": 68666,
	"./Script/Nabataean.js": 24224,
	"./Script/Nandinagari.js": 84531,
	"./Script/New_Tai_Lue.js": 38895,
	"./Script/Newa.js": 47228,
	"./Script/Nko.js": 45161,
	"./Script/Nushu.js": 46868,
	"./Script/Nyiakeng_Puachue_Hmong.js": 1429,
	"./Script/Ogham.js": 22101,
	"./Script/Ol_Chiki.js": 79887,
	"./Script/Old_Hungarian.js": 18598,
	"./Script/Old_Italic.js": 82703,
	"./Script/Old_North_Arabian.js": 63103,
	"./Script/Old_Permic.js": 18965,
	"./Script/Old_Persian.js": 5067,
	"./Script/Old_Sogdian.js": 56196,
	"./Script/Old_South_Arabian.js": 53889,
	"./Script/Old_Turkic.js": 26071,
	"./Script/Old_Uyghur.js": 62633,
	"./Script/Oriya.js": 51855,
	"./Script/Osage.js": 25212,
	"./Script/Osmanya.js": 19617,
	"./Script/Pahawh_Hmong.js": 65182,
	"./Script/Palmyrene.js": 28010,
	"./Script/Pau_Cin_Hau.js": 36651,
	"./Script/Phags_Pa.js": 40548,
	"./Script/Phoenician.js": 56055,
	"./Script/Psalter_Pahlavi.js": 82062,
	"./Script/Rejang.js": 27618,
	"./Script/Runic.js": 36940,
	"./Script/Samaritan.js": 88175,
	"./Script/Saurashtra.js": 41139,
	"./Script/Sharada.js": 46257,
	"./Script/Shavian.js": 43045,
	"./Script/Siddham.js": 52467,
	"./Script/SignWriting.js": 81598,
	"./Script/Sinhala.js": 8987,
	"./Script/Sogdian.js": 65782,
	"./Script/Sora_Sompeng.js": 43504,
	"./Script/Soyombo.js": 74927,
	"./Script/Sundanese.js": 46321,
	"./Script/Syloti_Nagri.js": 60767,
	"./Script/Syriac.js": 6856,
	"./Script/Tagalog.js": 89022,
	"./Script/Tagbanwa.js": 80592,
	"./Script/Tai_Le.js": 64021,
	"./Script/Tai_Tham.js": 556,
	"./Script/Tai_Viet.js": 71722,
	"./Script/Takri.js": 45020,
	"./Script/Tamil.js": 25826,
	"./Script/Tangsa.js": 47109,
	"./Script/Tangut.js": 57724,
	"./Script/Telugu.js": 78609,
	"./Script/Thaana.js": 85726,
	"./Script/Thai.js": 94875,
	"./Script/Tibetan.js": 67244,
	"./Script/Tifinagh.js": 26725,
	"./Script/Tirhuta.js": 11762,
	"./Script/Toto.js": 28085,
	"./Script/Ugaritic.js": 94831,
	"./Script/Vai.js": 79773,
	"./Script/Vithkuqi.js": 95690,
	"./Script/Wancho.js": 98519,
	"./Script/Warang_Citi.js": 13525,
	"./Script/Yezidi.js": 97269,
	"./Script/Yi.js": 81895,
	"./Script/Zanabazar_Square.js": 56589,
	"./Script_Extensions/Adlam.js": 39009,
	"./Script_Extensions/Ahom.js": 90427,
	"./Script_Extensions/Anatolian_Hieroglyphs.js": 22470,
	"./Script_Extensions/Arabic.js": 34074,
	"./Script_Extensions/Armenian.js": 79821,
	"./Script_Extensions/Avestan.js": 46570,
	"./Script_Extensions/Balinese.js": 72713,
	"./Script_Extensions/Bamum.js": 98246,
	"./Script_Extensions/Bassa_Vah.js": 37606,
	"./Script_Extensions/Batak.js": 67847,
	"./Script_Extensions/Bengali.js": 43170,
	"./Script_Extensions/Bhaiksuki.js": 24709,
	"./Script_Extensions/Bopomofo.js": 23759,
	"./Script_Extensions/Brahmi.js": 24585,
	"./Script_Extensions/Braille.js": 9105,
	"./Script_Extensions/Buginese.js": 48738,
	"./Script_Extensions/Buhid.js": 51110,
	"./Script_Extensions/Canadian_Aboriginal.js": 82026,
	"./Script_Extensions/Carian.js": 51548,
	"./Script_Extensions/Caucasian_Albanian.js": 9237,
	"./Script_Extensions/Chakma.js": 56091,
	"./Script_Extensions/Cham.js": 8591,
	"./Script_Extensions/Cherokee.js": 52310,
	"./Script_Extensions/Chorasmian.js": 61305,
	"./Script_Extensions/Common.js": 18763,
	"./Script_Extensions/Coptic.js": 86796,
	"./Script_Extensions/Cuneiform.js": 98934,
	"./Script_Extensions/Cypriot.js": 93494,
	"./Script_Extensions/Cypro_Minoan.js": 25384,
	"./Script_Extensions/Cyrillic.js": 1319,
	"./Script_Extensions/Deseret.js": 71234,
	"./Script_Extensions/Devanagari.js": 58612,
	"./Script_Extensions/Dives_Akuru.js": 68310,
	"./Script_Extensions/Dogra.js": 54375,
	"./Script_Extensions/Duployan.js": 69266,
	"./Script_Extensions/Egyptian_Hieroglyphs.js": 20166,
	"./Script_Extensions/Elbasan.js": 22650,
	"./Script_Extensions/Elymaic.js": 88998,
	"./Script_Extensions/Ethiopic.js": 35431,
	"./Script_Extensions/Georgian.js": 66568,
	"./Script_Extensions/Glagolitic.js": 28279,
	"./Script_Extensions/Gothic.js": 2680,
	"./Script_Extensions/Grantha.js": 22053,
	"./Script_Extensions/Greek.js": 99696,
	"./Script_Extensions/Gujarati.js": 35041,
	"./Script_Extensions/Gunjala_Gondi.js": 16672,
	"./Script_Extensions/Gurmukhi.js": 36264,
	"./Script_Extensions/Han.js": 74083,
	"./Script_Extensions/Hangul.js": 12079,
	"./Script_Extensions/Hanifi_Rohingya.js": 64933,
	"./Script_Extensions/Hanunoo.js": 52702,
	"./Script_Extensions/Hatran.js": 82348,
	"./Script_Extensions/Hebrew.js": 329,
	"./Script_Extensions/Hiragana.js": 88441,
	"./Script_Extensions/Imperial_Aramaic.js": 20852,
	"./Script_Extensions/Inherited.js": 22290,
	"./Script_Extensions/Inscriptional_Pahlavi.js": 33599,
	"./Script_Extensions/Inscriptional_Parthian.js": 4987,
	"./Script_Extensions/Javanese.js": 21663,
	"./Script_Extensions/Kaithi.js": 62228,
	"./Script_Extensions/Kannada.js": 19220,
	"./Script_Extensions/Katakana.js": 21544,
	"./Script_Extensions/Kayah_Li.js": 60778,
	"./Script_Extensions/Kharoshthi.js": 59687,
	"./Script_Extensions/Khitan_Small_Script.js": 41561,
	"./Script_Extensions/Khmer.js": 67789,
	"./Script_Extensions/Khojki.js": 23656,
	"./Script_Extensions/Khudawadi.js": 96818,
	"./Script_Extensions/Lao.js": 29080,
	"./Script_Extensions/Latin.js": 6306,
	"./Script_Extensions/Lepcha.js": 42483,
	"./Script_Extensions/Limbu.js": 25283,
	"./Script_Extensions/Linear_A.js": 6771,
	"./Script_Extensions/Linear_B.js": 36598,
	"./Script_Extensions/Lisu.js": 28977,
	"./Script_Extensions/Lycian.js": 81950,
	"./Script_Extensions/Lydian.js": 91113,
	"./Script_Extensions/Mahajani.js": 13311,
	"./Script_Extensions/Makasar.js": 13552,
	"./Script_Extensions/Malayalam.js": 44947,
	"./Script_Extensions/Mandaic.js": 43823,
	"./Script_Extensions/Manichaean.js": 82507,
	"./Script_Extensions/Marchen.js": 98016,
	"./Script_Extensions/Masaram_Gondi.js": 42202,
	"./Script_Extensions/Medefaidrin.js": 17050,
	"./Script_Extensions/Meetei_Mayek.js": 32721,
	"./Script_Extensions/Mende_Kikakui.js": 3115,
	"./Script_Extensions/Meroitic_Cursive.js": 14858,
	"./Script_Extensions/Meroitic_Hieroglyphs.js": 22771,
	"./Script_Extensions/Miao.js": 95192,
	"./Script_Extensions/Modi.js": 85625,
	"./Script_Extensions/Mongolian.js": 26004,
	"./Script_Extensions/Mro.js": 81496,
	"./Script_Extensions/Multani.js": 80084,
	"./Script_Extensions/Myanmar.js": 25279,
	"./Script_Extensions/Nabataean.js": 61525,
	"./Script_Extensions/Nandinagari.js": 20054,
	"./Script_Extensions/New_Tai_Lue.js": 56774,
	"./Script_Extensions/Newa.js": 83599,
	"./Script_Extensions/Nko.js": 87816,
	"./Script_Extensions/Nushu.js": 90737,
	"./Script_Extensions/Nyiakeng_Puachue_Hmong.js": 53226,
	"./Script_Extensions/Ogham.js": 59188,
	"./Script_Extensions/Ol_Chiki.js": 10336,
	"./Script_Extensions/Old_Hungarian.js": 74555,
	"./Script_Extensions/Old_Italic.js": 92580,
	"./Script_Extensions/Old_North_Arabian.js": 29650,
	"./Script_Extensions/Old_Permic.js": 77742,
	"./Script_Extensions/Old_Persian.js": 4250,
	"./Script_Extensions/Old_Sogdian.js": 18361,
	"./Script_Extensions/Old_South_Arabian.js": 86488,
	"./Script_Extensions/Old_Turkic.js": 82864,
	"./Script_Extensions/Old_Uyghur.js": 20250,
	"./Script_Extensions/Oriya.js": 68450,
	"./Script_Extensions/Osage.js": 36929,
	"./Script_Extensions/Osmanya.js": 28448,
	"./Script_Extensions/Pahawh_Hmong.js": 85117,
	"./Script_Extensions/Palmyrene.js": 51011,
	"./Script_Extensions/Pau_Cin_Hau.js": 69074,
	"./Script_Extensions/Phags_Pa.js": 73223,
	"./Script_Extensions/Phoenician.js": 94584,
	"./Script_Extensions/Psalter_Pahlavi.js": 75787,
	"./Script_Extensions/Rejang.js": 62909,
	"./Script_Extensions/Runic.js": 88281,
	"./Script_Extensions/Samaritan.js": 91102,
	"./Script_Extensions/Saurashtra.js": 98576,
	"./Script_Extensions/Sharada.js": 60160,
	"./Script_Extensions/Shavian.js": 74460,
	"./Script_Extensions/Siddham.js": 13434,
	"./Script_Extensions/SignWriting.js": 33259,
	"./Script_Extensions/Sinhala.js": 17682,
	"./Script_Extensions/Sogdian.js": 13219,
	"./Script_Extensions/Sora_Sompeng.js": 54775,
	"./Script_Extensions/Soyombo.js": 7458,
	"./Script_Extensions/Sundanese.js": 17268,
	"./Script_Extensions/Syloti_Nagri.js": 31824,
	"./Script_Extensions/Syriac.js": 33767,
	"./Script_Extensions/Tagalog.js": 51579,
	"./Script_Extensions/Tagbanwa.js": 9075,
	"./Script_Extensions/Tai_Le.js": 3858,
	"./Script_Extensions/Tai_Tham.js": 20179,
	"./Script_Extensions/Tai_Viet.js": 41117,
	"./Script_Extensions/Takri.js": 41757,
	"./Script_Extensions/Tamil.js": 62907,
	"./Script_Extensions/Tangsa.js": 61994,
	"./Script_Extensions/Tangut.js": 14651,
	"./Script_Extensions/Telugu.js": 33346,
	"./Script_Extensions/Thaana.js": 22765,
	"./Script_Extensions/Thai.js": 33296,
	"./Script_Extensions/Tibetan.js": 44049,
	"./Script_Extensions/Tifinagh.js": 98334,
	"./Script_Extensions/Tirhuta.js": 22011,
	"./Script_Extensions/Toto.js": 62646,
	"./Script_Extensions/Ugaritic.js": 48000,
	"./Script_Extensions/Vai.js": 44256,
	"./Script_Extensions/Vithkuqi.js": 56633,
	"./Script_Extensions/Wancho.js": 25084,
	"./Script_Extensions/Warang_Citi.js": 30024,
	"./Script_Extensions/Yezidi.js": 35734,
	"./Script_Extensions/Yi.js": 62588,
	"./Script_Extensions/Zanabazar_Square.js": 16770,
	"./index.js": 88265,
	"./unicode-version.js": 25312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79636;